import { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import { common } from '@ocean/ui'
import { ExternalLayer } from 'core/layers'
import AuthRouting, { routes as authRoutes } from 'modules/Auth/routing'
import SsoRouting, { routes as ssoRoutes } from 'modules/Sso/routing'

const { RouteChangeProgress } = common

const ExternalRouting = () => {
  return (
    <ExternalLayer>
      <Suspense fallback={<RouteChangeProgress />}>
        <Switch>
          <Route path={authRoutes.root} component={AuthRouting} />
          <Route path={ssoRoutes.root} component={SsoRouting} />
        </Switch>
      </Suspense>
    </ExternalLayer>
  )
}

export default ExternalRouting
